/*
 * vrtPSVLogbook.ts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSVLogbook: RouteRecordRaw = {
  path: '/powersteer/vlogbook',
  name: 'vrtPSVLogbook',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: '',
      name: 'vrtPSVLogbookCheckInOut',
      component: () => import('./vpgPSVLogbookCheckInOut.vue'),
    },
    {
      path: 'operate',
      name: 'vrtPSVLogbookOperate',
      component: () => import('./vpgPSVLogbookOperate.vue'),
    },
    {
      path: 'operate/mb',
      name: 'vrtPSVLogbookOperateMB',
      component: () => import('./vpgPSVLogbookOperateMB.vue'),
    },
    {
      path: 'trainer/mb/assign',
      name: 'vrtPSVLogbookAssignTraineeMB',
      component: () => import('./vpgPSVLogbookAssignTraineeMB.vue'),
    },
    {
      path: 'trainer/mb/operate',
      name: 'vrtPSVLogbookOperateTraineeMB',
      component: () => import('./vpgPSVLogbookOperateTraineeMB.vue'),
    },
    {
      path: 'operate/mb/trainer/add',
      name: 'vrtPSVLogbookOperateAddMB',
      component: () => import('./vpgPSVLogbookOperateAddMB.vue'),
    },
    {
      path: 'operate/addedit',
      name: 'vrtPSVLogbookOperateAddEdit',
      component: () => import('./vpgPSVLogbookOperateAddEdit.vue'),
    },
    {
      path: 'checkout',
      name: 'vrtPSVLogbookCheckOut',
      component: () => import('./vpgPSVLogbookCheckOut.vue'),
    },
    {
      path: 'checkin',
      name: 'vrtPSVLogbookCheckIn',
      component: () => import('./vpgPSVLogbookCheckIn.vue'),
    },
    {
      path: 'checkin/force',
      name: 'vrtPSVLogbookCheckInForce',
      component: () => import('./vpgPSVLogbookCheckInForces.vue'),
    },
    {
      path: 'list/crud',
      name: 'vrtPSVLogbookListCRUD',
      component: () => import('./vpgPSVLogbookListCRUD.vue'),
    },
    {
      path: 'operate/crud',
      name: 'vrtPSVLogbookOperateCRUD',
      component: () => import('./vpgPSVLogbookOperateCRUD.vue'),
    },
  ],
};

export default vrtPSVLogbook;
